import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import { CustomButton } from '../../components/button'
import { ContainerCustom, CustomColumn } from '../../components/layout'
import { Typography } from '../../components/typograph'
import { useHideSearchBar } from '../../store/context/navbar.context'
import getImageType from '../../utils/images/image-type'

const TextContent = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-top: 80px;
  max-width: 100%;
  min-width: 100%;

  @media (min-width: ${(p) => p.theme.breakpoints.md}) {
    align-items: flex-start;
    min-width: 300px;
    max-width: 300px;
  }
`

const Image = styled.img`
  margin-top: 80px;
  max-width: 100%;
  min-width: 100%;

  @media (min-width: ${(p) => p.theme.breakpoints.md}) {
    min-width: 600px;
    max-width: 600px;
  }
`

const { imageType } = getImageType()

const Error404 = () => {
  useHideSearchBar({})
  const { t } = useTranslation('404')
  const navigate = useNavigate()

  const onClick = () => {
    navigate('/')
  }

  return (
    <ContainerCustom>
      <CustomColumn
        flex
        align="center"
        heightDesktop="calc(100vh - 70px)"
        heightMobile="100vh"
        justifyD="space-between"
        direction="column"
        directionD="row"
      >
        <Image
          src={`${process.env.REACT_APP_CDN_IMAGE}/filters:${imageType}/site/common/error-404.png`}
        />
        <TextContent>
          <Typography title weight="semiBold" variant="large">
            Ops...
          </Typography>
          <Typography text variant="large" style={{ marginTop: '16px' }}>
            {t('404:DESCRIPTION')}
          </Typography>
          <CustomButton onClick={onClick} rounded style={{ marginTop: '24px' }}>
            {t('404:BUTTON')}
          </CustomButton>
        </TextContent>
      </CustomColumn>
    </ContainerCustom>
  )
}

export default Error404
